import React from "react"
import { Link } from "gatsby"
import AyampeImg from "../../../images/bg-ayampe-sunrise.png"
import MiamiImg from "../../../images/Miameee.png"
import MardelPlataImg from "../../../images/MDQ.png"

const Adventure = () => {
  return (
    <section>
      <div className="container mx-auto py-12">
        <h2 className="text-5xl text-center leading-snug">
          Your next <span className="text-tertiary">Adventure</span>{" "}
          <span className="font-bold block">awaits you . . .</span>
        </h2>
      </div>
      <div
        className="text-white bg-cover text-center lg:text-left mb-8"
        style={{ backgroundImage: `url(${AyampeImg})` }}
      >
        <div className="flex flex-row-reverse">
          <div className="w-full lg:w-1/2 bg-opacity-50 bg-tertiary px-12 py-60">
            <h3 className="text-5xl pb-4 leading-tight">
              <span className="block font-bold">Ayampe</span> Ecuador
            </h3>
            <p className="text-xl pb-12">
              Our Work and Travel experience from the heavenly Ayampe beach in
              Ecuador. Your ideal business trip with extra leisure time to enjoy
              the destination
            </p>
            <Link
              to="/contact"
              className="border-white border-solid border-2 hover:bg-neutral hover:text-variant hover:text-primary btn"
            >
              Contact us
            </Link>
          </div>
        </div>
      </div>
      {/* USA */}
      <div
        className="text-white bg-cover text-center lg:text-left mb-8"
        style={{ backgroundImage: `url(${MiamiImg})` }}
      >
        <div className="flex flex-row-reverse">
          <div className="w-full lg:w-1/2 bg-opacity-50 bg-tertiary px-12 py-60">
            <h3 className="text-5xl pb-4 leading-tight">
              <span className="block font-bold">Miami</span> USA
            </h3>
            <p className="text-xl pb-12">
              From our office in Miami, develop your profession and perfect your
              English in the most tropical city in the United States.
            </p>
            <Link
              to="/contact"
              className="border-white border-solid border-2 hover:bg-neutral hover:text-variant hover:text-primary btn"
            >
              Contact us
            </Link>
          </div>
        </div>
      </div>
      {/* ARGENTINA */}
      <div
        className="text-white bg-cover text-center lg:text-left mb-8"
        style={{ backgroundImage: `url(${MardelPlataImg})` }}
      >
        <div className="flex flex-row-reverse">
          <div className="w-full lg:w-1/2 bg-opacity-50 bg-tertiary px-12 py-60">
            <h3 className="text-5xl pb-4 leading-tight">
              <span className="block font-bold">Mar del Plata</span> Argentina
            </h3>
            <p className="text-xl pb-12">
              From Mar del Plata, where the Avalith adventure started. Our
              house, the coast, the beach and surfing as a lifestyle.
            </p>
            <Link
              to="/contact"
              className="border-white border-solid border-2 hover:bg-neutral hover:text-variant hover:text-primary btn"
            >
              Contact us
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Adventure
